/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Incidents_ResolvedInputs */



/**
* | output |
* | --- |
* | "Resolved" |
*
* @param {Partner_Status_Incidents_ResolvedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_incidents_resolved = /** @type {((inputs?: Partner_Status_Incidents_ResolvedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Incidents_ResolvedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Behoben")
	return /** @type {LocalizedString} */ ("Resolved")
});